import { defineMessages } from 'react-intl'

const messages = defineMessages({
  columnRegion: {
    id: 'PanelSection.columnRegion',
    description: 'Cabecera de columna',
    defaultMessage: 'Región'
  },
  columnCountry: {
    id: 'PanelSection.columnCountry',
    description: 'Cabecera de columna',
    defaultMessage: 'País'
  },
  columnEU: {
    id: 'PanelSection.columnEU',
    description: 'Cabecera de columna',
    defaultMessage: 'UE27 <small>(2020)</small>'
  },
  columnRanking: {
    id: 'PanelSection.columnRanking',
    description: 'Cabecera de columna',
    defaultMessage: 'Ranking'
  },
  columnEvolution: {
    id: 'PanelSection.columnEvolution',
    description: 'Cabecera de columna',
    defaultMessage: 'Evolución'
  },
  rankingTooltip: {
    id: 'PanelRowCointaner.rankingTooltip',
    description: 'Texto para explicar el ranking',
    defaultMessage: 'Posición de la región frente al resto de regiones de UE27 con datos disponibles'
  },
  dimensionLinkTooltip: {
    id: 'PanelRowCointaner.dimensionLinkTooltip',
    description: 'Tooltip para panel de dimensión',
    defaultMessage: 'Ver dimensión <strong>{dimensionTitle}</strong> con detalle y comparaciones adicionales'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Content/PanelSection/messages.js